import { getRoot } from 'mobx-state-tree';
import { isBool } from '../../../utils/types';
import { getType } from '../../Context/Actions/helpers';
import { PLATFORMS } from '../constants';
export const SettingsActions = self => ({
    setPrivacyConsent: setter => {
        self.isPrivacyApproved = setter;
    },
    setAutoOpen: setter => {
        self.isAutoOpen = setter;
    },
    setPluginSide: setter => {
        self.pluginSide = setter;
    },
    loadExternal: externalSettings => {
        const root = getRoot(self);
        self.isAlignExtensionTestSupported = externalSettings.isAlignExtensionTestSupported;
        if (isBool(externalSettings.autoOpen)) {
            self.isAutoOpen = externalSettings.autoOpen;
        }
        if (isBool(externalSettings.privacyApproval)) {
            self.isPrivacyApproved = externalSettings.privacyApproval;
        }
        if (isBool(externalSettings.isScoutEnabled)) {
            self.isScoutEnabled = externalSettings.isScoutEnabled;
        }
        if (isBool(externalSettings.isAllWebsitesPermissionsGranted)) {
            self.isAllWebsitesPermissionsGranted = externalSettings.isAllWebsitesPermissionsGranted;
        }
        if (isBool(externalSettings.shouldShowGmailOnBoarding)) {
            self.shouldShowGmailOnBoarding = externalSettings.shouldShowGmailOnBoarding;
        }
        if (isBool(externalSettings.isFeatureBranch)) {
            self.isFeatureBranch = externalSettings.isFeatureBranch;
        }
        if (!self.initialUrl) {
            self.initialUrl = externalSettings.url;
            const type = getType({ url: externalSettings.url, corePluginVersion: externalSettings.version });
            root.context.setType(type);
        }
        self.platform =
            externalSettings.platform === PLATFORMS.LINKEDIN_RECRUITER_PRO
                ? PLATFORMS.LINKEDIN_RECRUITER_LITE
                : externalSettings.platform || self.platform; // TODO: remove rec-lite patch, after get rec-pro html
        self.pluginTypeVariant = externalSettings.pluginTypeVariant || self.pluginTypeVariant;
        self.externalPluginVersion = externalSettings.version || self.externalPluginVersion;
        if (externalSettings.pluginSide) {
            self.pluginSide = externalSettings.pluginSide;
        }
    },
    setIsPluginOpen: setter => {
        self.isPluginOpen = setter;
    },
    setShowOnBoarding: setter => {
        self.shouldShowGmailOnBoarding = setter;
    },
    setPlatform: platform => {
        self.platform = platform;
    },
    setMoreMenuV2AnnouncementShown: setter => {
        self.isMoreMenuV2AnnouncementShown = setter;
    },
    setShouldShowSfdePromoBanner: setter => {
        self.shouldShowSfdePromoBanner = setter;
    },
    setShowCrmIntegrationsUpdateAnnouncement: setter => {
        self.shouldShowCrmIntegrationsUpdateAnnouncement = setter;
    },
});
